import styled from 'styled-components'
import {
  Card,
  Button,
  DatePicker,
  Input,
  Form,
  Typography,
  Table,
  Space,
  Divider,
  Modal,
  Tooltip,
  Select,
  message,
  Checkbox,
  Dropdown,
  Menu,
} from 'antd'
import {
  SearchInput,
  IconFont,
  SignTitle,
  TableTag,
  DeleteModal,
  SvgIcon,
  ConfirmInput,
  FilterForm,
  OptionType,
  ListPage,
  DraggingTableHeaders,
} from '@/components'
import { DownOutlined } from '@ant-design/icons'
const { Option } = Select
import { Key, useEffect, useMemo, useState, useRef } from 'react'
import Scrollbars from 'react-custom-scrollbars'
import { Group } from '.'
import { EventEmitter } from 'ahooks/lib/useEventEmitter'
import { GetTargetList } from '@/api/target'
import { useGetAuthorizeConfig } from '@/pages/account-center/authorize-manage/utils'
import { useBatchGroupCopy, useDeleteEmail, useGetEmailList, usePutName, usePutTag } from './utils'
import { useDebounce, useDebounceFn } from 'ahooks'
import { TablePaginationConfig, TableRowSelection } from 'antd/lib/table/interface'
import { ShowTotal } from '@/components/show-total'
import { Dispaths } from '@/types'
import { SearchInputTwo } from '@/components/search-input-two'
import { Label } from './label'
import { AddEmail } from './add-email'
import { AdvancedPopover, DTOption } from '@/components/advanced-search'
import { ListCollapse } from './list-collapse'
import { BatchAddModal } from '@/pages/phishing/target/batch-add-modal'
import { Message } from '@/components/message'
import { AxiosResponse } from 'axios'
import { t } from '@/i18n'
// import {TableTag} from '@/components/table-tag'
const { RangePicker } = DatePicker
const { useForm } = Form

interface Data {
  id: string
  email: string
  name: string
  dept_name: string
  origin_from: string
  inputTime: string
}

interface GroupItemProps {
  children: any
  id: string
  activeId?: string
  typeName: string
  onDelete: (id: string) => void | Promise<any>
  onClick: (id: string) => void | Promise<any>
}

interface ListProps {
  selectGroup: Group | undefined
  getEmailList$: EventEmitter<void>
  groupList: any[]
  tagList: any[]
  getGroupList: (data: any) => Promise<AxiosResponse<any>>
  visible: () => void
  handleBatchAdd: () => void
  getTagList: () => void
}
export const List = (props: ListProps) => {
  const {
    selectGroup,
    getEmailList$,
    groupList,
    visible,
    getTagList,
    handleBatchAdd,
    tagList,
    getGroupList,
  } = props

  // 获取邮箱授权数量
  const [authorizeConfig, runAuthorizeConfig] = useGetAuthorizeConfig()
  const [getEmailListParams, setGetEmailListParams] = useState<Omit<GetTargetList, 'group_id'>>({
    limit: 10,
    page: 1,
    tag_ids: [],
  })

  const [key, setKey] = useState(0)
  const { run: searchTask } = useDebounceFn(
    (name: string) => {
      getEmailList({ ...getEmailListParams, name_keyword: name, email_keyword: name, page: 1 })
      setGetEmailListParams({
        ...getEmailListParams,
        name_keyword: name,
        email_keyword: name,
        page: 1,
      })
    },
    {
      wait: 300,
    },
  )

  const { run } = useDebounceFn(
    d => {
      if (key === 0) setKey(key + 1)
    },
    {
      wait: 500,
    },
  )

  useEffect(() => {
    console.log('getEmailListParams', getEmailListParams)
    getEmailList(getEmailListParams)
  }, [getEmailListParams])

  useEffect(() => {
    runAuthorizeConfig().catch(() => {})
  }, [])

  let option = {
    name_keyword: {
      type: 'input',
      label: t('邮箱/姓名'),
    },
    tag_ids: {
      type: 'multiple',
      label: t('标签'),
      data: tagList || [],
      typeof: 'array',
    },
    origin_from: {
      type: 'radio',
      label: t('邮箱来源'),
      data: [
        { name: t('邮箱收集'), id: 1 },
        { name: t('手动添加'), id: 2 },
      ],
    },
    aware: {
      type: 'multiple',
      label: t('安全意识'),
      data: [
        { name: t('优秀'), id: '优秀' },
        { name: t('良好'), id: '良好' },
        { name: t('较差'), id: '较差' },
        { name: t('差'), id: '差' },
      ],

      typeof: 'array',
    },
    create_time: {
      type: 'dateNoTime',
      label: t('创建时间'),
      apiParams: ['start_time', 'end_time'],
    },
  } as OptionType

  useEffect(() => {
    run(option)
  }, [option])

  // const onFinish = values => {
  //   console.log('--', values)

  //   const { time, label, aware, email } = values
  //   setGetEmailListParams(origin => ({
  //     ...origin,
  //     start_time: time?.[0] || null,
  //     end_time: time?.[1] || null,
  //     tag_ids: label,
  //     aware: aware,
  //     page: 1,
  //   }))
  //   getEmailList({
  //     ...getEmailListParams,
  //     start_time: time?.[0] || null,
  //     end_time: time?.[1] || null,
  //     tag_ids: label,
  //     aware: aware,
  //     origin_from: email,
  //     page: 1,
  //   })
  // }
  const [createForm] = useForm()
  const setTags = () => {
    for (let index = 0; index < tagList?.length; index++) {
      tagList[index].visible = false
    }
  }

  useEffect(() => {
    setTags()
  }, [])

  const [filterParams, setFilterParams] = useState<{ [k: string]: string | number | undefined }>()
  const [listSelectKey, setlistSelectKey] = useState<Key[]>([])
  const [filterGroupName, setFilterGroupName] = useState('')
  const debounceFilterGroupName = useDebounce(filterGroupName, { wait: 500 })
  const filterGroups = useMemo(() => {
    if (!debounceFilterGroupName) return groupList.slice(1)
    return groupList.slice(1).filter(item => item.name.indexOf(debounceFilterGroupName) !== -1)
  }, [groupList, debounceFilterGroupName])
  const [groupListKeys, setGroupListKeys] = useState()

  const [emailList, getEmailList, getEmailListLoading, emailListMutate] = useGetEmailList({
    selectGroup,
    setGetEmailListParams,
    setlistSelectKey,
  })
  // const [form] = useForm()
  const [batchGroupCopy, batchGroupCopyLoading] = useBatchGroupCopy()

  const [deleteEmail, deleteEmailLoading] = useDeleteEmail()
  const [batchMoveModal, setBatchMoveModal] = useState({ visible: false, id: [] })
  const [batchAddModal, setBatchAddModal] = useState(false)
  const showBatchMoveModal = () => {
    // getGroupList({})
    setBatchMoveModal({ visible: true, id: [] })
  }
  const [deleteModal, setDeleteModal] = useState(false)

  const { run: getEmailListHandler } = useDebounceFn(getEmailList, {
    wait: 500,
  })

  /**table相关参数，为了适应封装组件，吧子组件与父组件合并 */
  const [form] = Form.useForm()

  const [putName] = usePutName()

  // let [GroupId, setGroupId] = useState<any>({ id: null })
  // const [, forceUpdate] = useState({})
  //因为使用组件里面用useMemo缓存了columns，因为闭包的原因，组件拿不到外面的变量，所以使用ref来处理
  const groupRef = useRef<any>(null)
  const GroupItem = (prop: GroupItemProps) => {
    const [isEditGroupName, setIsEditGroupName] = useState(false)
    const { children, id, onClick, typeName } = prop
    // const activeId = groupRef.current
    /**虽然拿到最新ID但是感觉没啥用 */
    const isActive = id === groupRef.current
    // console.log('activeId', activeId, id, groupRef.current)

    return (
      <GroupItemContainer
        isActive={isActive}
        onClick={() => {
          onClick(id)
        }}
        key={id}
      >
        <Typography.Text className="text" ellipsis={{ tooltip: true }}>
          {children}
        </Typography.Text>
        {/* <div className="text" key={id}>
           {children}
          </div> */}
        <>
          {isEditGroupName ? (
            <ConfirmInput
              className="confirm-input"
              // style={{ width: 220 }}
              name={typeName as string}
              id={selectGroup?.id}
              onCancel={() => {
                setIsEditGroupName(false)
              }}
              onOk={async name => {
                if (!(name || '').trim()) {
                  setIsEditGroupName(false)
                  return
                }
                putName({ id: id, name: name })
                  .then(() => getEmailList(getEmailListParams))
                  .catch(() => {})
                setIsEditGroupName(false)
              }}
            />
          ) : (
            <>
              <IconFont
                style={{ cursor: 'pointer', fontSize: '16px' }}
                // onClick={() => selectGroup?.id && setIsEditGroupName(true)}
                onClick={() => setIsEditGroupName(true)}
                type={'icon-huabanfuben'}
                className="delete-icon"
              />
            </>
          )}
        </>
      </GroupItemContainer>
    )
  }
  const [memo, setMemo] = useState({ id: null, visible: false, tag: null })
  // 列表展开收起
  let [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([])
  const expandedKeysRef = useRef([])
  const Open = (record, keys) => {
    // console.log(record, keys, expandedRowKeys, expandedKeysRef.current)
    if (record?.id === expandedKeysRef.current?.[0]) {
      setExpandedRowKeys((expandedRowKeys = []))
      expandedKeysRef.current = []
    } else {
      expandedKeysRef.current = [record.id]
      setExpandedRowKeys([record.id])
      // getTerminalPluginDetail(record.id).catch(() => {})
    }
  }
  useEffect(() => {
    setExpandedRowKeys([])
  }, [emailList?.items])
  const [putTag] = usePutTag()
  const confirmAddGroup = values => {
    const { target } = values
    if (tagList?.length + 1 === target?.length) {
      target.pop()
    }
    putTag({ ids: [memo.id], tag_ids: target })
      .then(() => {
        getEmailList(getEmailListParams)
        setMemo({ id: null, visible: false, tag: null })
      })
      .catch(() => {})
  }
  /**------------------------------------------------------------------------------------------ */
  const columns = [
    {
      title: t('邮箱'),
      dataIndex: 'email',
      width: 200,
      fixed: 'left',
      render: (value: string) => (
        <Typography.Text
          ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
          style={{
            maxWidth: '0.75rem',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {value}
        </Typography.Text>
      ),
    },
    {
      title: t('姓名'),
      width: 80,
      dataIndex: 'name',
      render: (value: string, data) => (
        <div style={{ width: '0.5rem' }}>
          <GroupItem
            // activeId={groupRef.current}
            children={value || '-'}
            id={data.id}
            typeName={value}
            onClick={() => {
              // setGroupId(data)
              groupRef.current = data.id
              // forceUpdate({})
            }}
            onDelete={() => {}}
          />
        </div>
      ),
    },
    // {
    //   title: !selectGroup?.id && '部门',
    //   // width: '10%',
    //   width: !selectGroup?.id && '10%',
    //   dataIndex: !selectGroup?.id && 'dept_name',
    //   editable: !selectGroup?.id && true,
    //   render: (value: string) => (
    //     <Typography.Text
    //       style={{
    //         width: !selectGroup?.id ? '80px' : 0,
    //       }}
    //       ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
    //     >
    //       {!selectGroup?.id && <>{value}</>}
    //     </Typography.Text>
    //   ),
    // },
    {
      title: t('标签'),
      dataIndex: 'tag_ids',
      width: 170,
      searchType: 'multiple',
      render: (_, record) => {
        const value = record?.tag_list
        return (
          <div style={{}}>
            {value?.map((item, index) => {
              let arr = ['#65BDC0', '#1E2243', '#558492']
              if (index <= 1) {
                return (
                  <TableTag
                    background={
                      (item === '已离职' && '#AFAFAF') ||
                      (item === '新入职' && '#67C23A') ||
                      (item === '已评估' && '#3257B9') ||
                      (item === '邮箱收集' && '#ED7780') ||
                      (item === '业务邮箱' && '#AA56FF') ||
                      arr[Math.round(index)]
                    }
                    color="#fff"
                    key={index}
                    style={{
                      whiteSpace: item.length < 1 ? 'nowrap' : '',
                      marginRight: 4,
                      marginBottom: 4,
                    }}
                  >
                    {item}
                  </TableTag>
                )
              }
              if (index === 2) {
                return <span key={index}>...</span>
              }
            })}
            {value ? '' : '-'}
            <IconFont
              type="icon-huabanfuben"
              className="delete-icon"
              onClick={() => {
                let arr = []
                tagList?.map(item => {
                  if (value?.some(i => i === item.name)) {
                    arr.push(item?.id)
                  }
                })
                form.setFieldsValue({ target: arr })
                setMemo({ visible: true, id: record?.id, tag: value })
              }}
            />
          </div>
        )
      },
    },
    {
      title: t('邮箱来源'),
      dataIndex: 'origin_from',
      editable: false,
      searchType: 'radio',
      width: 95,
      render: (value: string) => {
        if (value === '1') {
          return (
            <div style={{ width: 65 }}>
              <TableTag bgColor="#ED7780" color="#ED7780">
                {t('邮箱收集')}
              </TableTag>
            </div>
          )
        }
        if (value === '2') {
          return (
            <div style={{ width: 65 }}>
              <TableTag bgColor="#558492" color="#558492">
                {t('手动添加')}
              </TableTag>
            </div>
          )
        }
      },
    },
    {
      title: t('创建时间'),
      width: 170,
      dataIndex: 'create_time',
      editable: false,
      searchType: 'dateNoTime',
      render: (_: any, record: any) => (
        <div style={{ width: '85px', whiteSpace: 'nowrap' }}>
          {record.create_time?.substring(0, 10)}
        </div>
      ),
    },
    {
      width: 140,
      title: (
        <div style={{ width: 80 }}>
          {t('安全意识')}
          <Tooltip
            placement="top"
            title={t('最近一次任务')}
            getTooltipContainer={() => document.getElementById('table-box')}
          >
            <IconFont
              type="icon-tishi"
              style={{ marginLeft: 5, color: '#999', cursor: 'pointer' }}
            />
          </Tooltip>
        </div>
      ),

      dataIndex: 'aware',
      editable: false,
      searchType: 'multiple',
      render: (_: any, record: any) => (
        <div style={{ maxWidth: '150px' }}>
          {record.aware === '优秀' && (
            <TableTag background="#D6F4C7" color="#5BC825">
              {record.aware}
            </TableTag>
          )}
          {record.aware === '良好' && (
            <TableTag background="#E2E4FF" color="#2973FF">
              {record.aware}
            </TableTag>
          )}
          {record.aware === '较差' && (
            <TableTag background="#FFEBB4" color="#FFA709">
              {record.aware}
            </TableTag>
          )}
          {record.aware === '差' && (
            <TableTag background="#FFC9C9" color="#FF2929">
              {record.aware}
            </TableTag>
          )}
          {record.aware !== '优秀' &&
            record.aware !== '良好' &&
            record.aware !== '较差' &&
            record.aware !== '差' &&
            '-'}
        </div>
      ),
    },
    {
      title: t('操作'),
      width: '15%',
      render: (_: any, record: Data) => (
        <Space split={<Divider type="vertical" />} style={{ width: 175 }}>
          <Typography.Link onClick={() => Open(record, expandedRowKeys)}>
            <IconFont type="icon-tongjichaxun" style={{ color: '#4238C9', fontSize: 16 }} />
            <span style={{ marginLeft: 6 }}>{t('个人统计')}</span>
          </Typography.Link>
          {
            <Dropdown
              trigger={['click']}
              autoAdjustOverflow
              getPopupContainer={() => document.getElementById('table-box')}
              overlay={
                <Menu
                  items={[
                    {
                      key: '1',
                      label: (
                        <Typography.Link
                          onClick={() => {
                            showBatchMoveModal()
                            setBatchMoveModal({ visible: true, id: [record.id] })
                          }}
                        >
                          <div className="operate">
                            <TableIcon type="icon-icon_list_zhuanyi" style={{ fontSize: '16px' }} />
                            <span style={{ marginLeft: 6 }}>{t('转移到')}</span>
                          </div>
                        </Typography.Link>
                      ),
                    },
                    {
                      key: '2',
                      label: (
                        <Typography.Link
                          onClick={() => {
                            setlistSelectKey([record.id])
                            setDeleteModal(true)
                          }}
                        >
                          <div className="operate">
                            <TableIcon type="icon-shanchu-m" style={{ fontSize: '16px' }} />
                            <span style={{ marginLeft: 6 }}>{t('删除')}</span>
                          </div>
                        </Typography.Link>
                      ),
                    },
                  ]}
                />
              }
            >
              <div style={{ color: '#4238C9' }}>
                <Space size={4}>
                  {t('更多')}
                  <DownOutlined />
                </Space>
              </div>
            </Dropdown>
          }
        </Space>
      ),
    },
  ]

  const closeModal = (val = false) => {
    setBatchAddModal(false)
    if (val) {
      try {
        getEmailList(getEmailListParams)
        handleBatchAdd()
        getTagList()
      } catch (err) {}
    }
  }
  const deleteEmailHandler = async () => {
    try {
      await deleteEmail({
        ids: listSelectKey as number[],
      })
      setlistSelectKey([])
      setDeleteModal(false)
      getEmailList(getEmailListParams)
    } catch (err) {}
  }

  const batchGroupCopyHandler = async () => {
    try {
      if (!groupListKeys) {
        Message.error(t('请选择部门'))
        return
      }
      await batchGroupCopy({
        group_id: groupListKeys,
        ids: batchMoveModal.id.length > 0 ? batchMoveModal.id : (listSelectKey as number[]),
      })
      setBatchMoveModal({ visible: false, id: [] })
      setFilterGroupName('')
      setlistSelectKey([])
      setGroupListKeys(null)
      getEmailList(getEmailListParams)
      getGroupList({}).catch(() => {})
    } catch (error) {}
  }
  const [addEmail, setAddEmail] = useState(false)
  const addEmailClose = (data: boolean) => {
    if (data) {
      getEmailList(getEmailListParams)
    }
    setAddEmail(false)
  }
  const [isModalVisible, setIsModalVisible] = useState({ visible: false, id: [] })
  const isModa = (isConfirm: boolean) => {
    setIsModalVisible({ visible: false, id: [] })
    if (isConfirm) {
      setlistSelectKey([])
    }
  }
  getEmailList$.useSubscription(() => {
    getEmailListHandler(getEmailListParams)
  })
  useEffect(() => {
    let arr = []
    tagList?.map(item => {
      arr.push(item.id)
    })
    arr.push(0)
    form.setFieldsValue({ groupList: arr })
    createForm.resetFields()
  }, [tagList, selectGroup])
  return (
    <ListContainer>
      <TitleContainer>
        <SignTitle style={{ width: 100 }}>{t('评估目标')}</SignTitle>
        {selectGroup?.id ? (
          <div style={{ display: 'flex' }}>
            <Tooltip
              title={
                authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                  ? t('请提升验证邮箱授权数量')
                  : ''
              }
            >
              <Button
                type={'primary'}
                onClick={() => {
                  setAddEmail(true)
                }}
                disabled={authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0}
              >
                {t('添加')}
              </Button>
            </Tooltip>
          </div>
        ) : (
          <Tooltip
            title={
              authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                ? t('请提升验证邮箱授权数量')
                : ''
            }
          >
            <Button
              onClick={() => {
                // console.log(123123)
                setBatchAddModal(true)
                // visible()
              }}
              type="primary"
              style={{ marginLeft: '8px', paddingLeft: 17, paddingRight: 17 }}
              disabled={authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0}
            >
              {t('批量添加')}
            </Button>
          </Tooltip>
        )}
      </TitleContainer>
      <FormItem component={false}>
        <Modal
          title={<SignTitle show>{t('标注')}</SignTitle>}
          visible={memo.visible}
          onOk={() => {
            form.submit()
          }}
          onCancel={() => {
            setMemo({ visible: false, id: null, tag: null })
            form.resetFields()
          }}
          confirmLoading={getEmailListLoading}
          centered
        >
          <Form form={form} layout={'vertical'} onFinish={confirmAddGroup}>
            <Form.Item name="target" label={t('标签')}>
              <Select
                placeholder={t('请选择标签')}
                mode="multiple"
                showSearch={false}
                showArrow
                maxTagCount={4}
                maxTagTextLength={6}
              >
                {tagList?.map(item => (
                  <Option value={item?.id} key={item?.id}>
                    {item?.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </FormItem>
      {/* <div style={{ padding: '0 20px' }} id="table-box">
         <ListPage
           columns={columns as any}
           className="tableHover"
           cardProps={{
             title: (
               <TitleContainer>
                 <SignTitle style={{ width: 100 }}>评估目标</SignTitle>
                 {selectGroup?.id ? (
                   <div style={{ display: 'flex' }}>
                     <Button
                       type={'primary'}
                       onClick={() => {
                         setAddEmail(true)
                       }}
                     >
                       添加
                     </Button>
                   </div>
                 ) : (
                   <Button
                     onClick={() => {
                       // console.log(123123)
                       setBatchAddModal(true)
                       // visible()
                     }}
                     type="primary"
                     style={{ marginLeft: '8px', paddingLeft: 17, paddingRight: 17 }}
                   >
                     批量添加
                   </Button>
                 )}
               </TitleContainer>
             ),
           }}
           searchParams={getEmailListParams}
           total={emailList?.total}
           setSearchParams={setGetEmailListParams}
           setSelectedRowKeys={setlistSelectKey}
           selectedRowKeys={listSelectKey}
           dataSource={emailList?.items}
           filterOption={option}
           // cardTop={200}
           loading={getEmailListLoading}
           batchOperation={
             <Space
               split={<Divider type={'vertical'} />}
               onClick={e => {
                 e.stopPropagation()
               }}
             >
               <div>批量操作</div>
               <Unbind
                 active={listSelectKey?.length > 0}
                 onClick={() => {
                   setDeleteModal(listSelectKey?.length > 0 && true)
                 }}
               >
                 <SvgIcon name={'batch_remove'} className="icon-delete" />
                 <span>批量删除</span>
               </Unbind>
               <Unbind
                 active={listSelectKey?.length > 0}
                 onClick={() => listSelectKey.length > 0 && showBatchMoveModal()}
               >
                 <SvgIcon name={'transfer-active'} className="icon-delete" />
                 <span>批量转移</span>
               </Unbind>
               <Unbind
                 active={listSelectKey?.length > 0}
                 onClick={() =>
                   listSelectKey.length > 0 &&
                   setIsModalVisible({ visible: true, id: listSelectKey })
                 }
               >
                 <SvgIcon name={'label-active'} className="icon-delete" />
                 <span>批量标注</span>
               </Unbind>
             </Space>
           }
           onReset={() => {
             setGetEmailListParams(origin => ({
               ...origin,
               name: undefined,
               end_time: undefined,
               start_time: undefined,
               aware: undefined,
               origin_from: undefined,
               tag_ids: undefined,
               page: 1,
               limit: 10,
             }))
           }}
         />
        </div> */}
      <Task>
        <FilterForm
          option={option}
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          setSearchParams={setGetEmailListParams}
          onReset={() => {
            setGetEmailListParams(origin => ({
              ...origin,
              name_keyword: undefined,
              email_keyword: undefined,
              end_time: undefined,
              start_time: undefined,
              aware: undefined,
              origin_from: undefined,
              tag_ids: undefined,
              page: 1,
              limit: 10,
            }))
          }}
        />

        {listSelectKey.length > 0 && (
          <TopBar>
            <div className="flex">
              <div>{t('批量操作')}</div>
              <Divider type="vertical" style={{ marginLeft: 12, marginRight: 16 }} />
              {
                <Space size={16}>
                  <div className="box-item">
                    <Typography.Link
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setDeleteModal(listSelectKey?.length > 0 && true)
                      }}
                    >
                      <SvgIcon name={'batch_remove'} className="icon-delete" />
                      <span style={{ color: '#333' }}>{t('批量删除')}</span>
                    </Typography.Link>
                  </div>
                  <div className="box-item">
                    <Typography.Link
                      style={{ cursor: 'pointer' }}
                      onClick={() => listSelectKey.length > 0 && showBatchMoveModal()}
                    >
                      <SvgIcon name={'transfer-active'} className="icon-delete" />
                      <span style={{ color: '#333' }}>{t('批量转移')}</span>
                    </Typography.Link>
                  </div>
                  <div className="box-item">
                    <Typography.Link
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        listSelectKey.length > 0 &&
                        setIsModalVisible({ visible: true, id: listSelectKey })
                      }
                    >
                      <SvgIcon name={'label-active'} className="icon-delete" />
                      <span style={{ color: '#333' }}>{t('批量标注')}</span>
                    </Typography.Link>
                  </div>
                </Space>
              }
            </div>
            <div className="end" onClick={() => setlistSelectKey([])}>
              <IconFont type="icon-guanbi" className="close" />
            </div>
          </TopBar>
        )}
        <div style={{ padding: '0 20px' }} id="table-box">
          <DraggingTableHeaders
            columns={columns}
            option={option}
            key={key}
            // setFilterParams={setFilterParams}
            // filterParams={filterParams}
            dataSource={emailList?.items}
            loading={getEmailListLoading}
            scroll={{ y: `calc(440px - ${50}px)`, x: 'max-content' }}
            expandable={{
              expandedRowRender: record => <ListCollapse record={record} />,
              // expandedRowRender: () => <>111</>,
              rowExpandable: record => true,
            }}
            expandedRowKeys={expandedRowKeys}
            expandIconColumnIndex={-1}
            rowKey="id"
            searchParams={getEmailListParams}
            setSearchParams={setGetEmailListParams}
            filterParams={filterParams}
            setFilterParams={setFilterParams}
            total={emailList?.total}
            selectedRowKeys={listSelectKey}
            setSelectedRowKeys={setlistSelectKey}
          />
        </div>
      </Task>
      <DeleteModal
        confirmLoading={deleteEmailLoading}
        onOk={deleteEmailHandler}
        onCancel={() => {
          setDeleteModal(false)
        }}
        visible={deleteModal}
        text={t('此操作将永久删除,是否继续?')}
      />

      <Label
        visible={isModalVisible}
        close={isModa}
        tagList={tagList}
        listSelectKey={listSelectKey}
        getEmailList={getEmailList}
        getEmailListParams={getEmailListParams}
      />

      <BatchAddModal visible={batchAddModal} closeModal={closeModal} />
      <Modal
        onOk={batchGroupCopyHandler}
        confirmLoading={batchGroupCopyLoading}
        onCancel={() => {
          setBatchMoveModal({ visible: false, id: [] })
          setFilterGroupName('')
          setGroupListKeys(null)
        }}
        title={<SignTitle show>{t('转移到')}</SignTitle>}
        destroyOnClose
        centered
        visible={batchMoveModal.visible}
        bodyStyle={{ height: '470px' }}
      >
        <BatchAddCtainer>
          <SearchInputTwo
            inputProps={{
              placeholder: t('请输入部门'),
              value: filterGroupName,
              onChange: e => setFilterGroupName(e.target.value),
            }}
          />

          <Scrollbars className="list">
            {filterGroups.map(group => (
              <ListItem key={group.id}>
                <Checkbox
                  checked={groupListKeys === group?.id}
                  onChange={e => {
                    if (e.target.checked) {
                      setGroupListKeys(group?.id)
                    } else {
                      setGroupListKeys(null)
                    }
                  }}
                >
                  <div className="text">{group.name}</div>
                </Checkbox>
              </ListItem>
            ))}
          </Scrollbars>
        </BatchAddCtainer>
      </Modal>
      <AddEmail
        selectGroup={selectGroup}
        tagList={tagList}
        visible={addEmail}
        close={addEmailClose}
      />
    </ListContainer>
  )
}

const Task = styled.div`
  flex-grow: 1;
  //display: flex;
  height: 100%;
  //flex-wrap: wrap;
  //align-content: space-between;
  .ant-dropdown-menu {
    padding: 4px;
  }
  .ant-dropdown-menu-item {
    border-radius: 4px;
    padding: 0;
    /* &:hover {
      color: #4238C9;
      background-color: #e7e9f3;
    } */
  }
  .operate {
    width: 110px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 12px;
    gap: 8px;
  }
`

const FormItem = styled(Form)`
  .mySelfClassName {
    background-color: red;
  }
  .expand {
    width: 100%;
  }
  .ant-table-tbody > tr > td {
    padding: 12px 0 !important;
  }
  .menu-item {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 32px 5px 12px;
    gap: 8px;
  }
`
interface GroupItemContainerProps {
  isActive: boolean
}
const Delete = styled.div<GroupItemContainerProps>`
  width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  background: #f2f3f5;
  border-radius: 6px;
  display: flex;
  /* margin-top: 16px; */
  margin-right: 10px;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  background-color: ${props => (props.isActive ? '#F2F3F5' : '')};
  transition: 0.3s;
  &:hover {
    background-color: ${props => (props.isActive ? 'rgba(245, 63, 63, 0.1)' : '')};
    .icon-delete {
      width: 12px;
      stroke: ${props => (props.isActive ? '#f53f3f' : '')};
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
const Transfer = styled.div<GroupItemContainerProps>`
  width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  background: #f2f3f5;
  border-radius: 6px;
  display: flex;
  /* margin-top: 16px; */
  margin-right: 10px;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  background-color: ${props => (props.isActive ? '#F2F3F5' : '')};
  transition: 0.3s;
  &:hover {
    background-color: ${props => (props.isActive ? 'rgba(101, 189, 192, 0.1)' : '')};
    .icon-delete {
      width: 12px;
      /* stroke: ${props => (props.isActive ? '#f53f3f' : '')}; */
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
const LabelButton = styled.div<GroupItemContainerProps>`
  width: 100px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  background: #f2f3f5;
  border-radius: 6px;
  display: flex;
  /* margin-top: 16px; */
  margin-right: 10px;
  align-items: center;
  cursor: ${props => (props.isActive ? 'pointer' : 'no-drop')};
  color: ${props => (props.isActive ? '#333' : '#999')};
  justify-content: center;
  background-color: ${props => (props.isActive ? '#F2F3F5' : '')};
  transition: 0.3s;
  &:hover {
    background-color: ${props => (props.isActive ? 'rgba(27, 42, 81, 0.15)' : '')};
    .icon-delete {
      width: 12px;
      /* stroke: ${props => (props.isActive ? '#f53f3f' : '')}; */
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
interface BatchProps {
  active: Boolean
}
const ListItem = styled.div<BatchProps>`
  padding-left: 14px;
  margin: 12px;
  display: flex;
  align-items: center;
  height: 32px;
  background: ${props => (props.active ? '#E7E9F3' : '#f7f7f7')};
  border-radius: 6px;
  display: flex;
  align-items: center;
  &:hover {
    background: #e7e9f3;
  }
  .text {
    flex-grow: 1;
    padding-left: 10px;
    overflow: hidden;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
const BatchAddCtainer = styled.div`
  width: 417px;
  margin: auto;
  .interval {
    margin-right: 12px;
  }
  .select-all {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .list {
    height: 100% !important;
    min-height: 370px;
    margin-top: 16px;
    border: 1px solid rgb(217, 217, 217);
    border-radius: 4px;
    padding: 0 12px;
  }
`

const ListContainer = styled(Card)`
  flex-grow: 1;
  border-radius: 8px;
  /* min-height: 100%; */
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .ant-card-head-title {
    border-bottom: 1px solid #ececec;
    padding-bottom: 20px;
  }
  .ant-card-body {
    padding: 20px 0;
  }
  .delete-icon {
    color: #999;
    font-size: 16px;
    &:hover {
      color: #4238c9;
    }
  }

  .ant-table-expanded-row {
    background-color: #fff;
    &:hover > td {
      background-color: #fff;
    }
    td {
      background-color: #fff;
    }
  }
`
const TitleContainer = styled.div`
  margin: 0 20px;
  margin-bottom: 8px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const TableIcon = styled(IconFont)`
  /* cursor: pointer;
  color:#2973FF; */
`
const GroupItemContainer = styled.div<GroupItemContainerProps>`
  height: 32px;
  border-radius: 4px;
  padding-right: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  .delete-icon {
    color: #999;
    &:hover {
      color: #4238c9;
    }
  }
  .text {
    line-height: 1.5;
    /* flex-grow: 1; */
    max-width: 0.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .confirm-input {
    min-width: 0.5rem;
    /* width: 220px; */
  }
  .ant-input-borderless[disabled] {
    background: #fff;
    color: #333;
  }
`

const TopBar = styled.div`
  height: 32px;
  background: #f1f3f8;
  border-radius: 6px;
  border: 1px solid #d3d5e6;
  margin-top: 13px;
  margin-bottom: 10px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .flex {
    display: flex;
    align-items: center;
  }
  .box-item {
    padding: 4px 5px;
    border-radius: 6px;
    &:hover {
      background-color: #ffffff;
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
  .end {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      background: #ffffff;
    }
    &:active {
      box-shadow: 0px 0px 8px 2px #fffffff7;
    }
  }
  .close {
    font-size: 12px;
    color: #999999;
  }
`
interface DeleteItem {
  active: boolean
}
const Unbind = styled.div<DeleteItem>`
  width: 100px;
  height: 24px;
  font-size: 14x;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  justify-content: center;
  background: #f2f3f5;
  transition: 0.3s;
  &:hover {
    background: #fff;
    .icon-delete {
      width: 12px;
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`
